module.exports = __webpack_public_path__ + "static/taruni-63ff94e1ee1b89fb8792261900810da1.jpg";